import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { clamp } from '@ps-gui/shared-utils';
import { RoundToIntPipe } from '../../pipes';

@Component({
  selector: 'shared-core-loading-page',
  imports: [NgClass, RoundToIntPipe],
  template: `
    @let percent = loadingProgress * 100 | roundToInt;
    <div
      class="pointer-events-none absolute top-0 right-0 bottom-0 left-0 flex flex-col items-center justify-center bg-white transition-all duration-[0.5s]"
      [ngClass]="{
        'opacity-0 blur-3xl': loadingProgress > 0.9,
      }">
      <div
        class="flex w-1/2 max-w-md flex-col gap-10 transition-all duration-[1s]"
        [ngClass]="{
          'opacity-0 blur-3xl': loadingProgress > 0.9,
        }">
        <div class="flex h-[300px] items-end justify-center">
          <img src="@shared-core/images/vyda-diff.png" loading="eager" alt="Logo" />
        </div>
        <div
          class="relative flex h-10 items-center justify-center overflow-hidden rounded-full border text-center">
          <div
            class="absolute top-0 right-full bottom-0 left-0"
            [style.background]="'repeating-linear-gradient(-45deg, #006436 0px, #006436 10px, #cf8806 10px, #cf8806 20px)'"
            [style.background-attachment]="'fixed'"
            [style.background-position]="'0 0'"
            [style.width]="loadingProgress * 100 + '%'"></div>
          <span style="text-shadow: 0 0 2px black" class="z-10 text-lg font-bold text-white">
            {{ percent }} %
          </span>
        </div>
      </div>
    </div>
  `,
})
export class LoadingPageComponent {
  @Input({ required: true, transform: (value: number) => clamp(value, 0, 1) }) loadingProgress = 0;
}
